import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { default as Actions } from '../actions';
import * as CommonActions from '../../common/actions';

import './Home.scss';
import { withFlags } from '../../flags/Flags';

import { BrandBand } from '../../common/components';
import { Header, AssetOverview, AssetEditWizard, McMenu } from '../components/';

export class AssetDashboard extends Component {
  componentDidMount() {
    this.props.actions.getRules();
  }

  render() {
    const {
      assets,
      attributes,
      catalogs,
      contentBuilder,
      modals,
      rules,
      tags,
      ...others
    } = this.props;
    const isLoading = !!assets.loadContext.browser;

    return withFlags(flags => {
      return (
        <McMenu
          flags={this.props.flags}
          history={this.props.history}
          route="/distribution/assets"
        >
          <BrandBand>
            <Header
              route={this.props.match}
              navigation={this.props.navigation}
            />
            <AssetOverview
              modals={modals}
              assets={assets.data}
              attributes={attributes || {}}
              catalogs={catalogs}
              isLoading={isLoading !== false}
              loadContext={assets.loadContext}
              rules={rules?.data?.rules}
              source={this.props.match?.params?.tab || 'distribution'}
              {...others}
            />
            <AssetEditWizard
              actions={this.props.actions}
              modals={modals}
              assets={assets}
              assetTypes={assets.data.types}
              attributes={attributes}
              contentBuilder={contentBuilder}
              rules={rules?.data?.rules}
              tags={tags}
            />
          </BrandBand>
        </McMenu>
      );
    });
  }
}

AssetDashboard.propTypes = {
  actions: PropTypes.object,
  assets: PropTypes.object.isRequired,
  attributes: PropTypes.array,
  catalogs: PropTypes.object.isRequired,
  flags: PropTypes.object,
  modals: PropTypes.object,
  navigation: PropTypes.object,
  rules: PropTypes.object,
  location: PropTypes.object,
  tags: PropTypes.object,
  contentBuilder: PropTypes.object,
  toast: PropTypes.object
};

function mapStateToProps(state) {
  return {
    assets: state.ecs.assets,
    attributes: state.ecs.attributes.data,
    catalogs: state.ecs.catalogs,
    contentBuilder: state.ecs.contentBuilder,
    flags: state.ecs.flags,
    navigation: state.ecs.navigation,
    rules: state.ecs.rules,
    tags: state.ecs.tags,
    modals: state.modals,
    toast: state.toast
  };
}

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...Actions, ...CommonActions }, dispatch)
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(AssetDashboard);
